import http from './http'

const veiculosService = {
  getAll: page => http.get(`/veiculos?page=${page}`).then(result => result.data),
  getById: id => http.get(`/veiculos/${id}`).then(result => result.data.data),
  getByAll: () => http.get(`/veiculosall`).then(result => result.data),
  getByNome: (str, page) => http.get(`/veiculogetnome/${str}?page=${page}`).then(result => result.data),
  getVeiculosHabilitados: () => http.get(`/veiculoshabilitados`).then(result => result.data),
  delete: id => http.delete(`/veiculodelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/veiculo`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/veiculo/${data.id}`,
    data
  }).then(result => result.data.data)
}

export default veiculosService
